/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { Dimensions, StyleSheet, View, Text } from 'react-native';
import Image from '@web/components/common/Image';
import { ThemeProvider, Button } from 'react-native-elements-light';
const Modal = React.lazy(() => import('@web-components/common/Modal'));
import Colors from '~global/Colors';
import { purple } from '@web/styles/buttons';
import * as authActions from '~store/user/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
const screenWidth = Dimensions.get('window').width;

const ModalConsent = (props) => {
  const dispatch = useDispatch();
  const isShow = useSelector((state) => state.modal.consent.isShow);
  const user = useSelector((state) => state.auth.user);
  const userId = user?._id;

  // ...........methods
  const confirmHandler = async () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'consent' });
    dispatch({ type: 'SET_FRESH_LOGIN', data: true });
    dispatch({ type: 'MODAL/SHOW', modalName: 'completedProfile' });
    // .......integrate api for lilla_member
    await dispatch(
      authActions.updateUser(userId, {
        is_lilla_member: true,
        user_name: user?.user_name,
      }),
    );
  };

  return (
    <>
      <Modal isVisible={isShow} transparent>
        <View style={styles.modalOverlay}>
          <View style={styles.modal}>
            <Text style={[styles.modalTitle, { marginBottom: 10 }]}>
              Approval
            </Text>
            <View style={{ marginVertical: 10, alignItems: 'center' }}>
              <Image
                style={{ width: 250 }}
                source={require('~assets/soco-lilla.png')}
                resizeMode="contain"
              />
            </View>
            <Text style={[styles.modalText, { marginBottom: 15 }]}>
              Hai, {user?.first_name}! Dengan login menggunakan SOCO ID, kamu
              juga akan terdaftar sebagai member Lilla.
            </Text>
            <View style={styles.buttonContainer}>
              <ThemeProvider theme={purple}>
                <Button
                  title="Agree"
                  containerStyle={styles.containerStyle}
                  onPress={confirmHandler}
                />
              </ThemeProvider>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  modal: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    padding: 20,
    width: screenWidth - 32,
  },
  modalTitle: {
    color: Colors.black0,
    fontSize: 14,
    fontFamily: 'figtree-black',
    lineHeight: 19,
  },
  modalText: {
    color: Colors.black0,
    fontSize: 13,
    fontFamily: 'figtree-medium',
    lineHeight: 22,
    textAlign: 'center',
  },
  buttonContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: -5,
  },
  containerStyle: {
    flex: 1,
    marginHorizontal: 5,
  },
  modalOverlay: {
    backgroundColor: 'rgba(0, 0, 0, .5)',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ModalConsent;
